import React from 'react'
import { NavbarContextType } from './types'

const NavbarContext = React.createContext<NavbarContextType>(
  {} as NavbarContextType
)

export default NavbarContext
